"use client";

import { CircleCheck as CheckCircle2, Info, PhoneCall, ShieldCheck } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Pricing() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: tableRef,
    isVisible: tableVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: cardRef,
    isVisible: cardVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const pricingRows = [{
    service: "Systemické konstelace",
    description: "Pochopení souvislostí v chování, vztazích a rozhodování",
    duration: "[ 60 MIN ]",
    price: "--- Kč",
    tooltip: ""
  }, {
    service: "SCIO feedback",
    description: "Mapování zátěže a podpora regenerace nervového systému",
    duration: "[ 60 MIN ]",
    price: "--- Kč",
    tooltip: ""
  }, {
    service: "Bachovy esence",
    description: "Emoční stabilita a zklidnění přetíženého nervového systému",
    duration: "[ 60 MIN ]",
    price: "--- Kč",
    tooltip: ""
  }, {
    service: "Odpínání",
    description: "Transformace prostřednictvím práce s podvědomím",
    duration: "[ 60 MIN ]",
    price: "--- Kč",
    tooltip: ""
  }, {
    service: "Kurzy",
    description: "Vedení zaměřené na vlastní sílu a praktické změny",
    duration: "[ 60 MIN ]",
    price: "--- Kč",
    tooltip: ""
  }, {
    service: "Neuro-náplasti",
    description: "Inovativní technologie neuro-modulace pro podporu nervového systému bez chemie",
    duration: "[ 30 MIN ]",
    price: "--- Kč",
    tooltip: ""
  }];
  const reassurances = [{
    icon: PhoneCall,
    title: "Úvodní hovor zdarma",
    description: "Zavolejte nám a zjistěte, zda je naše cesta tou pravou pro vás."
  }, {
    icon: CheckCircle2,
    title: "Bezpečné prostředí",
    description: "Garantujeme naprostou diskrétnost a respekt k vašemu příběhu."
  }, {
    icon: ShieldCheck,
    title: "Etický přístup",
    description: "Pracujeme s úctou k vaší duši a tempu, které právě potřebujete."
  }];
  return <section data-section-id="851" id="ceník-služeb" className="bg-background text-foreground pt-28 pb-24 px-6">
      
    </section>;
}